const SmartUpload = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M7.275 16.564h6.472V15.07H7.275v1.494Zm0-3.983h9.434l.024-.014v-1.48H7.275v1.494Z"
        />
        <path
            fill="currentColor"
            d="M5.342 18.804h8.86a5.45 5.45 0 0 0 .679 1.493H5.34c-.502 0-.928-.174-1.276-.523a1.737 1.737 0 0 1-.523-1.277V5.172c0-.503.174-.929.523-1.277a1.737 1.737 0 0 1 1.277-.523h13.325c.503 0 .929.174 1.277.523.349.348.523.774.523 1.277v6.753a5.509 5.509 0 0 0-1.494-.068V5.172a.293.293 0 0 0-.095-.21.293.293 0 0 0-.211-.097H5.342a.293.293 0 0 0-.21.096.293.293 0 0 0-.097.21v13.326c0 .077.032.147.096.211a.293.293 0 0 0 .21.096Z"
        />
        <path fill="currentColor" d="M7.275 8.599h9.458V7.106H7.275v1.493Z" />
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M19.446 14a.498.498 0 0 0-.945 0l-.392 1.178a1.743 1.743 0 0 1-1.102 1.102l-1.178.392a.498.498 0 0 0 0 .944l1.178.393a1.744 1.744 0 0 1 1.102 1.101l.392 1.178a.498.498 0 0 0 .945 0l.392-1.177a1.744 1.744 0 0 1 1.102-1.102l1.178-.393a.498.498 0 0 0 0-.944l-1.178-.392a1.742 1.742 0 0 1-1.102-1.102L19.446 14Zm-1.054 2.563a2.73 2.73 0 0 0 .582-.86 2.737 2.737 0 0 0 1.44 1.441 2.739 2.739 0 0 0-1.44 1.441 2.737 2.737 0 0 0-1.441-1.44c.32-.138.612-.335.86-.582Z"
            clip-rule="evenodd"
        />
    </svg>
);

export default SmartUpload;
